import React from 'react';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import { NamedLink, Button } from '../../../components';
import ListYourItemsButton from '../ListYourItemsButton/ListYourItemsButton';
import css from './SellBand.module.css';
import clothesImage from './clothesImage.jpg';

// "For sellers" band — mirrors the refreshed design mockup's sell section.
// The two checks stay consistent with the site's "free to list, free to sell"
// message (the donation comes from Causee's profits, not seller fees). The
// "Pick the charity" check was left out per the launch spec.
const CheckIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const UploadIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 3v12M8 7l4-4 4 4" />
    <path d="M4 15v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4" />
  </svg>
);

const STEPS = [
  {
    titleId: 'CustomLandingPage.sellBand.step.free.title',
    textId: 'CustomLandingPage.sellBand.step.free.text',
  },
  {
    titleId: 'CustomLandingPage.sellBand.step.keep.title',
    textId: 'CustomLandingPage.sellBand.step.keep.text',
  },
];

const SellBand = () => {
  const intl = useIntl();

  return (
    <section className={css.section}>
      <div className={css.grid}>
        <div className={css.content}>
          <span className={css.eyebrow}>
            <FormattedMessage id="CustomLandingPage.sellBand.eyebrow" />
          </span>
          <h2 className={css.heading}>
            <FormattedMessage id="CustomLandingPage.sellBand.heading" />
          </h2>
          <p className={css.body}>
            <FormattedMessage id="CustomLandingPage.sellBand.body" />
          </p>

          <div className={css.steps}>
            {STEPS.map(step => (
              <div className={css.step} key={step.titleId}>
                <span className={css.check} aria-hidden="true">
                  <CheckIcon />
                </span>
                <span className={css.stepText}>
                  <strong>
                    <FormattedMessage id={step.titleId} />
                  </strong>
                  <span>
                    <FormattedMessage id={step.textId} />
                  </span>
                </span>
              </div>
            ))}
          </div>

          <div className={css.ctas}>
            <ListYourItemsButton linkClassName={css.ctaLink} buttonClassName={css.primaryCta}>
              <FormattedMessage id="CustomLandingPage.sellBand.ctaPrimary" />
            </ListYourItemsButton>
            <NamedLink className={css.ctaLink} name="BulkUploadPage">
              <Button className={css.secondaryCta}>
                <UploadIcon />
                <FormattedMessage id="CustomLandingPage.sellBand.ctaBulk" />
              </Button>
            </NamedLink>
            <NamedLink className={css.ctaLink} name="FlufConnectPage">
              <Button className={css.secondaryCta}>
                <FormattedMessage id="CustomLandingPage.sellBand.ctaFluf" />
              </Button>
            </NamedLink>
          </div>

          <p className={css.bulkHelp}>
            <strong>
              <FormattedMessage id="CustomLandingPage.sellBand.bulkHelp.title" />
            </strong>{' '}
            <FormattedMessage id="CustomLandingPage.sellBand.bulkHelp.text" />
          </p>
        </div>

        <div className={css.art}>
          <img
            className={css.artPhoto}
            src={clothesImage}
            alt={intl.formatMessage({ id: 'CustomLandingPage.sellBand.imageAlt' })}
          />
          <span className={css.pinned}>
            <CheckIcon />
            <FormattedMessage id="CustomLandingPage.sellBand.pinned" />
          </span>
          <div className={css.preview}>
            <div className={css.thumb} />
            <div className={css.info}>
              <div className={css.t1}>
                <FormattedMessage id="CustomLandingPage.sellBand.previewTitle" />
              </div>
            </div>
            <div className={css.price}>
              <FormattedMessage id="CustomLandingPage.sellBand.previewPrice" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SellBand;
